import sc from 'styled-components';
import { Col, Row } from 'antd';
import React from 'react';


export default ({ children }) => (
  <Row>
    <Col sm={23} md={11} lg={10}>
      {React.Children.toArray(children)[0] || ''}
    </Col>
    <Col sm={1} md={2} lg={4} />
    <Col sm={24} md={11} lg={10}>
      {React.Children.toArray(children)[1] || ''}
    </Col>
  </Row>
);
